<div class="row form-row">
    <div class="col-12 p-3">
        <p class="text-start pt-2 pb-2">{{ (label() + ".willDeleted") | translate}} "{{ deleteInformation() | uppercase }}"
            {{ (label() + ".canNotRevert") | translate}}</p>
        <p class="text-start pb-2">{{ (label() + ".wantDelete") | translate}}</p>
    </div>
    <div class="d-flex justify-content-between align-items-center">
      <app-close-button
        (onCloseClicked)="onClose()">
      </app-close-button>
      <app-delete-button
        [hasPermission]="true"
        (onDeleteClicked)="onDelete()">
      </app-delete-button>
    </div>
</div>
